export default function Contact() {
  return (
    <div>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, var(--primary-color) 0%, #0052a3 100%)',
        color: 'white',
        padding: '40px 28px',
        borderRadius: '12px',
        marginBottom: '40px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          margin: '0 0 12px 0',
          lineHeight: '1.2'
        }}>
          Get In Touch
        </h1>
        <p style={{
          fontSize: '16px',
          margin: 0,
          opacity: '0.95'
        }}>
          We're here to help and answer any questions you might have
        </p>
      </div>

      {/* Contact Info Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '40px'
      }}>
        {/* Phone */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '28px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '2px solid #3b82f6' + '20',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(59, 130, 246, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            background: '#3b82f6' + '15',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#3b82f6',
            fontSize: '24px',
            marginBottom: '16px'
          }}>
            <i className="ti ti-phone" aria-hidden="true"></i>
          </div>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '700',
            marginBottom: '8px',
            color: 'var(--text-dark)',
            margin: '0 0 8px 0'
          }}>
            Helpline
          </h3>
          <p style={{
            color: 'var(--text-secondary)',
            fontSize: '14px',
            lineHeight: '1.8',
            margin: 0
          }}>
            <strong style={{ color: 'var(--text-dark)' }}>Toll-free: 1533</strong><br />
            Monday - Friday<br />
            8:00 AM - 5:00 PM<br />
            <span style={{ fontSize: '12px', color: 'var(--text-light)' }}>Nairobi Time (GMT+3)</span>
          </p>
        </div>

        {/* Email */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '28px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '2px solid #10b981' + '20',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(16, 185, 129, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            background: '#10b981' + '15',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981',
            fontSize: '24px',
            marginBottom: '16px'
          }}>
            <i className="ti ti-mail" aria-hidden="true"></i>
          </div>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '700',
            marginBottom: '8px',
            color: 'var(--text-dark)',
            margin: '0 0 8px 0'
          }}>
            Email
          </h3>
          <p style={{
            color: 'var(--text-secondary)',
            fontSize: '14px',
            lineHeight: '1.8',
            margin: 0
          }}>
            <strong style={{ color: 'var(--text-dark)', fontSize: '14px' }}>General Inquiries:</strong><br />
            <a href="mailto:info@socialcare.go.ke" style={{
              color: '#10b981',
              textDecoration: 'none',
              fontWeight: '500'
            }}>info@socialcare.go.ke</a><br />
            <br />
            <strong style={{ color: 'var(--text-dark)', fontSize: '14px' }}>Support:</strong><br />
            <a href="mailto:support@socialcare.go.ke" style={{
              color: '#10b981',
              textDecoration: 'none',
              fontWeight: '500'
            }}>support@socialcare.go.ke</a>
          </p>
        </div>

        {/* Office */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '28px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '2px solid #f59e0b' + '20',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(245, 158, 11, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            background: '#f59e0b' + '15',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b',
            fontSize: '24px',
            marginBottom: '16px'
          }}>
            <i className="ti ti-map-pin" aria-hidden="true"></i>
          </div>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '700',
            marginBottom: '8px',
            color: 'var(--text-dark)',
            margin: '0 0 8px 0'
          }}>
            Head Office
          </h3>
          <p style={{
            color: 'var(--text-secondary)',
            fontSize: '14px',
            lineHeight: '1.8',
            margin: 0
          }}>
            Government Social Protection Center<br />
            Block A, Eastern Wing<br />
            1st Floor<br />
            P.O Box 16936<br />
            Nairobi, Kenya
          </p>
        </div>
      </div>

      {/* Fraud Reporting */}
      <div style={{
        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
        borderRadius: '12px',
        padding: '32px',
        border: '2px solid #ef4444' + '30',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '16px',
          color: '#7f1d1d',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          margin: '0 0 16px 0'
        }}>
          <i className="ti ti-shield-alert" style={{ fontSize: '24px' }} aria-hidden="true"></i>
          Report Fraud or Suspicious Activity
        </h2>
        <p style={{
          color: '#991b1b',
          fontSize: '14px',
          marginBottom: '16px',
          lineHeight: '1.6'
        }}>
          Help us keep the program secure by reporting any scams, fraudulent schemes, or suspicious activities. All reports are taken seriously and investigated promptly.
        </p>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '16px'
        }}>
          <div>
            <p style={{
              fontSize: '12px',
              fontWeight: '700',
              color: '#991b1b',
              textTransform: 'uppercase',
              margin: '0 0 6px 0'
            }}>
              <i className="ti ti-phone" style={{ marginRight: '6px' }} aria-hidden="true"></i>
              Fraud Hotline
            </p>
            <p style={{
              fontSize: '15px',
              fontWeight: '600',
              color: '#7f1d1d',
              margin: 0
            }}>
              1533
            </p>
          </div>
          <div>
            <p style={{
              fontSize: '12px',
              fontWeight: '700',
              color: '#991b1b',
              textTransform: 'uppercase',
              margin: '0 0 6px 0'
            }}>
              <i className="ti ti-mail" style={{ marginRight: '6px' }} aria-hidden="true"></i>
              Fraud Email
            </p>
            <p style={{
              fontSize: '14px',
              color: '#7f1d1d',
              margin: 0
            }}>
              <a href="mailto:fraud@socialcare.go.ke" style={{
                color: '#991b1b',
                textDecoration: 'underline',
                fontWeight: '500'
              }}>fraud@socialcare.go.ke</a>
            </p>
          </div>
        </div>
      </div>

      {/* FAQs */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '24px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          margin: '0 0 24px 0'
        }}>
          <i className="ti ti-help-circle" style={{ color: 'var(--primary-color)', fontSize: '24px' }} aria-hidden="true"></i>
          Frequently Asked Questions
        </h2>
        <div style={{ display: 'grid', gap: '20px' }}>
          {[
            {
              q: 'What are your office hours?',
              a: 'Our office is open Monday to Friday, 8:00 AM to 5:00 PM Nairobi Time (GMT+3). You can call our helpline 1533 during these hours.'
            },
            {
              q: 'How long does it take to receive a response?',
              a: 'We typically respond to emails within 24-48 hours. For urgent matters, please call our hotline at 1533.'
            },
            {
              q: 'Can I visit your office?',
              a: 'Yes! Our office is located at Block A, Eastern Wing, 1st Floor of the Government Social Protection Center in Nairobi. Please note appointments are recommended.'
            },
            {
              q: 'How do I report a scam?',
              a: 'You can report suspicious activity by calling 1533, emailing fraud@socialcare.go.ke, or visiting your nearest police station.'
            },
            {
              q: 'Is my personal information secure?',
              a: 'Yes, we take data security seriously. All information is encrypted and protected according to government standards.'
            },
            {
              q: 'Which language should I use to contact you?',
              a: 'You can contact us in English or Swahili. Our team will assist you in your preferred language.'
            }
          ].map((item, idx) => (
            <div key={idx} style={{
              paddingBottom: '20px',
              borderBottom: idx < 5 ? '1px solid var(--border-light)' : 'none'
            }}>
              <h3 style={{
                fontSize: '15px',
                fontWeight: '600',
                marginBottom: '8px',
                color: 'var(--text-dark)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                margin: '0 0 8px 0'
              }}>
                <i className="ti ti-help" style={{ color: 'var(--primary-color)' }} aria-hidden="true"></i>
                {item.q}
              </h3>
              <p style={{
                fontSize: '14px',
                color: 'var(--text-secondary)',
                margin: 0,
                lineHeight: '1.6',
                paddingLeft: '24px'
              }}>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

